import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { AccuracyWeaponCategories, MatchRoundAccuracyStatsCategories } from '../../../../../helpers';
import { IRoundBoxScoreDto } from '../../../../../WorldDoomLeague';
import MatchRoundWeaponsAccuracyTabs from './MatchRoundWeaponsAccuracyTabs';
import MatchRoundWeaponsAccuracyTabsView from './MatchRoundWeaponsAccuracyTabsView';

interface MatchRoundWeaponsAccuracyCategoryTabsViewProps {
    category: AccuracyWeaponCategories;
    categoryObject: MatchRoundAccuracyStatsCategories;
    activeWeapon: string;
    setActiveWeapon: React.Dispatch<React.SetStateAction<string>>;
    perRoundBoxScore: IRoundBoxScoreDto
};

const MatchRoundWeaponsAccuracyCategoryTabsView = (props: MatchRoundWeaponsAccuracyCategoryTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.category}>
                <TabPane tabId={AccuracyWeaponCategories.Accuracy}>
                    <MatchRoundWeaponsAccuracyTabs activeWeapon={props.activeWeapon} setActiveWeapon={props.setActiveWeapon} category={props.categoryObject} />
                    <MatchRoundWeaponsAccuracyTabsView activeWeapon={props.activeWeapon} categoryObject={props.categoryObject} perRoundBoxScore={props.perRoundBoxScore} />
                </TabPane>
                <TabPane tabId={AccuracyWeaponCategories.AccuracyWithFlag}>
                    <MatchRoundWeaponsAccuracyTabs activeWeapon={props.activeWeapon} setActiveWeapon={props.setActiveWeapon} category={props.categoryObject} />
                    <MatchRoundWeaponsAccuracyTabsView activeWeapon={props.activeWeapon} categoryObject={props.categoryObject} perRoundBoxScore={props.perRoundBoxScore} />
                </TabPane>
            </TabContent>
        </React.Fragment>);
};

export default MatchRoundWeaponsAccuracyCategoryTabsView;